module.exports = __webpack_public_path__ + "media/images/flags/4x3/pcn-c568083abaa11481ad50c20c599d2591.svg";